import React from 'react';
import { generateSounding } from '@/lib/mockWeatherData';
import type { SoundingLevel } from '@/lib/mockWeatherData';

interface WindBarbTableProps {
  hour: number;
  soundingData?: SoundingLevel[] | null;
}

function dirToArrow(deg: number): string {
  const dirs = ['↑','↗','→','↘','↓','↙','←','↖'];
  return dirs[Math.round(deg / 45) % 8];
}

function windColor(speed: number): string {
  if (speed < 28) return '#34d399';
  if (speed < 46) return '#fbbf24';
  if (speed < 75) return '#f87171';
  return '#a78bfa';
}

export default function WindBarbTable({ hour, soundingData }: WindBarbTableProps) {
  const rawSounding = soundingData && soundingData.length > 0
    ? soundingData
    : generateSounding(hour);
  const levels = rawSounding.filter((_, i) => i % 2 === 0);

  return (
    <div>
      <h3 className="text-sm font-semibold mb-3" style={{ color: 'var(--text-primary)' }}>Vent par Niveau</h3>
      <div className="space-y-1.5">
        {levels.map((lvl) => (
          <div
            key={`wind-barb-${lvl.pressure}`}
            className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-white/5 transition-colors"
            style={{ border: '1px solid var(--border)' }}
          >
            <span
              className="font-mono-data text-xs font-semibold w-12 text-right flex-shrink-0"
              style={{ color: 'var(--text-muted)' }}
            >
              {lvl.pressure}
            </span>
            <span className="text-xs flex-shrink-0" style={{ color: 'var(--text-muted)' }}>hPa</span>
            <span
              className="font-mono-data text-xs flex-shrink-0 w-16"
              style={{ color: 'var(--text-muted)' }}
            >
              {lvl.altitude}m
            </span>
            <span
              className="text-base flex-shrink-0"
              style={{ color: windColor(lvl.windSpeed) }}
              title={`${lvl.windDir}°`}
            >
              {dirToArrow(lvl.windDir)}
            </span>
            <span
              className="font-mono-data text-sm font-semibold"
              style={{ color: windColor(lvl.windSpeed) }}
            >
              {lvl.windSpeed} km/h
            </span>
            <div
              className="flex-1 h-1.5 rounded-full overflow-hidden"
              style={{ backgroundColor: 'var(--border)' }}
            >
              <div
                className="h-1.5 rounded-full"
                style={{
                  width: `${Math.min(lvl.windSpeed / 150 * 100, 100)}%`,
                  backgroundColor: windColor(lvl.windSpeed),
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
